module.exports = __webpack_public_path__ + "img/cycle-4.bba48662.jpg";